import { createSlice } from "@reduxjs/toolkit";

export const autoResponseSettingSlice = createSlice({
  name: "autoResponseSetting",
  initialState: {
    getAutoResponseSettingResult: false,
    getAutoResponseSettingLoading: false,
    getAutoResponseSettingError: false,
    addAutoResponseSettingResult: false,
    addAutoResponseSettingLoading: false,
  },
  reducers: {
    autoResponseSettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_AUTORESPONSESETTING":
          return {
            ...state,
            getAutoResponseSettingResult: payload.data,
            getAutoResponseSettingLoading: payload.loading,
            getAutoResponseSettingError: payload.error,
          };
        case "ADD_AUTORESPONSESETTING":
          return {
            ...state,
            addAutoResponseSettingResult: payload.data,
            addAutoResponseSettingLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { autoResponseSettingReducers } = autoResponseSettingSlice.actions;

export default autoResponseSettingSlice.reducer;
